/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTiposBodegas from 'Infotrack@Modelos/smartStock/tiposBodegas';
import ITiposBodegas from 'Infotrack@Modelos/smartStock/tiposBodegas/entidades/tiposBodegas';

export default class ControladorModeloTiposBodegas {
    private modeloTiposBodegas: ModeloTiposBodegas;
    constructor() {
        this.modeloTiposBodegas = new ModeloTiposBodegas();
    }

    public consultarTiposBodegas() {
        return this.modeloTiposBodegas.consultarTiposBodegas().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTiposBodegas(tiposBodegas: ITiposBodegas) {
        await this.modeloTiposBodegas.crearTiposBodegas(tiposBodegas);
    }

    public async editarTiposBodegas(tiposBodegas: ITiposBodegas) {
        await this.modeloTiposBodegas.editarTiposBodegas(tiposBodegas);
    }
    public async eliminarTiposBodegas(tiposBodegas: ITiposBodegas) {
        await this.modeloTiposBodegas.eliminarTiposBodegas(tiposBodegas);
    }

    public validarEntidad(tiposBodegas: ITiposBodegas): boolean {
        if (tiposBodegas.TipoBodegaDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarTiposBodegasPorFiltro(tiposBodegas: Partial<ITiposBodegas>) {
        return (await this.modeloTiposBodegas.consultarTiposBodegasPorFiltro(tiposBodegas)).data.Entidades;
    }
}
